import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconActionRedo';
/** Renders an SVG icon. */
const SvgActionRedo = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M23.293 7.293a1 1 0 0 0 0 1.414L25.586 11H10a7 7 0 1 0 0 14h6a1 1 0 1 0 0-2h-6a5 5 0 0 1 0-10h15.586l-2.293 2.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 0 0-1.414 0"
      />
    </svg>
  );
};
SvgActionRedo.displayName = displayName;
export default SvgActionRedo;
